const toNumberOrNull = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const n = Number(String(value).replace(",", "."));
  return Number.isFinite(n) ? n : null;
};

const defaultGet = (field) => (row) => row?.[field];

export const buildFuelRowsWithDeltaKm = (rows = [], options = {}) => {
  const {
    getId = (row) => row?.id || row?._id,
    getPlate = defaultGet("vehiclePlate"),
    getDateKey = defaultGet("date"),
    getOdometer = defaultGet("odometerKm"),
    getStoredDelta = defaultGet("deltaKm"),
    includeRow = () => true
  } = options;

  const byPlate = new Map();

  rows.forEach((row, index) => {
    if (!includeRow(row)) return;
    const plate = String(getPlate(row) || "").toLocaleUpperCase("tr-TR").replace(/\s+/g, "").trim();
    const dateKey = String(getDateKey(row) || "");
    const odometer = toNumberOrNull(getOdometer(row));
    if (!plate || !dateKey || odometer === null) return;
    if (!byPlate.has(plate)) byPlate.set(plate, []);
    byPlate.get(plate).push({ row, index, plate, dateKey, odometer });
  });

  const out = new Map();

  byPlate.forEach((items) => {
    items.sort((a, b) => {
      const dateCompare = a.dateKey.localeCompare(b.dateKey);
      return dateCompare !== 0 ? dateCompare : a.index - b.index;
    });

    items.forEach((item, idx) => {
      const storedDelta = toNumberOrNull(getStoredDelta(item.row));
      const prev = items[idx - 1];
      const computedDelta = storedDelta !== null
        ? storedDelta
        : (prev ? item.odometer - prev.odometer : 0);
      const id = [
        getId(item.row) || "__noid__",
        item.plate,
        item.dateKey,
        item.odometer,
        item.index
      ].join("|");

      out.set(item.index, {
        ...item.row,
        _computedKm: computedDelta,
        _computedKmHasPrevious: Boolean(prev),
        _computedKmDateKey: item.dateKey,
        _computedKmPlateKey: item.plate,
        _computedKmSourceIndex: item.index,
        _computedKmDetailId: `km|${id}`
      });
    });
  });

  return rows.map((row, index) => out.get(index) || row);
};
